import { useEffect } from 'react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { RouterProvider } from 'react-router-dom';

import { router } from '@/config/routes';
import { loadASAPP } from '@utils/asappLoader';
import '@config/i18n';

const envConfig = {
  issuer: import.meta.env.VITE_APP_OKTA_ISSUER,
  clientId: import.meta.env.VITE_APP_OKTA_CLIENT_ID,
  redirectUri: import.meta.env.VITE_APP_OKTA_REDIRECT_URI,
  baseURL: import.meta.env.VITE_APP_BASE_URL,
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
};
const oktaAuth = new OktaAuth(envConfig);

const App = () => {
  const origin = window.location.origin;

  useEffect(() => {
    if (import.meta.env.VITE_ENABLE_ASAPP_CHAT === 'true') {
      loadASAPP();
    }
  }, []);

  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    window.location.replace(toRelativeUrl(originalUri || '/', origin));
  };

  const customAuthHandler: Parameters<typeof Security>[0]['onAuthRequired'] = () => {
    window.location.replace('/login');
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
      onAuthRequired={customAuthHandler}
    >
      <RouterProvider router={router} />
    </Security>
  );
};

export default App;
